export * from './FoodWareDishIcon';
export * from './FoodWareDishIcon16Light';
export * from './FoodWareDishIcon16Regular';
export * from './FoodWareDishIcon16Solid';
export * from './FoodWareDishIcon20Light';
export * from './FoodWareDishIcon20Regular';
export * from './FoodWareDishIcon20Solid';
export * from './FoodWareDishIcon24Regular';
export * from './FoodWareDishIcon24Solid';
export * from './FoodWareDishIcon32Regular';
export * from './FoodWareDishIcon64Regular';
